import Vue from "vue";
import VueRouter from "vue-router";

// 修复重复点击跳转同一个路由的提示
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

// 本地开发：http://localhost:8080

const routes = [
  // /* -------- 专题版块 START -------- */
  // // 官网专题列表
  {
    path: '/subjectList',
    name: 'List',
    component: () => import('../views/list/List.vue')
  },
  // // 图片展
  {
    path: '/pictheme',
    name: 'Pictheme',
    component: () => import('../views/picshow/Pictheme.vue')
  },
  // // 媒体中心-重庆车展
  {
    path: '/exhibition',
    name: 'Exhibition',
    component: () => import('../views/exhibition/Exhibition.vue')
  },
  // // 粤港澳车展
  {
    path: '/exhibitionyga',
    name: 'Exhibitionyga',
    component: () => import('../views/exhibition-yga/Exhibition.vue')
  },
  //  成都车展
  {
    path: '/exhibitioncd',
    name: 'Exhibitioncd',
    component: () => import('../views/exhibition-cd/Exhibition.vue')
  },
  // 成都车展24届
  {
    path: '/exhibitioncd24th',
    name: 'exhibitioncd24th',
    component: () => import('../views/exhibition-cd24th/Exhibition.vue')
  },
  // // 北京车展
  {
    path: '/exhibitionbj',
    name: 'Exhibitionbj',
    component: () => import('../views/exhibition-bj/Exhibition.vue')
  },
  // // 上海车展
  {
    path: '/exhibitionsh',
    name: 'Exhibitionsh',
    component: () => import('../views/exhibition-sh/Exhibition.vue')
  },
  // // 300万下线
  {
    path: '/offline',
    name: 'Offline',
    component: () => import('../views/offline/Offline.vue')
  },
  // // 威然试驾
  {
    path: '/viloranDrive',
    name: 'ViloranDrive',
    component: () => import('../views/viloran-drive/ViloranDrive.vue')
  },
  // // 斯柯达试驾
  {
    path: '/skodaDrive',
    name: 'SkodaDrive',
    component: () => import('../views/skoda-drive/SkodaDrive.vue')
  },
  // // 千里行
  {
    path: '/phev',
    name: 'phev',
    component: () => import('../views/phev/phev.vue')
  },
  // // 长沙工厂专题
  {
    path: '/factory',
    name: 'factory',
    component: () => import('../views/factory/factory.vue')
  },
  // meb工厂专题-现场直播
  {
    path: '/meb',
    name: 'meb',
    component: () => import('../views/meb/scene.vue')
  },
  // meb工厂专题-工厂概述
  {
    path: '/overview',
    name: 'meb2',
    component: () => import('../views/meb/summary.vue')
  },
  // meb工厂专题-车间工艺
  {
    path: '/Technology',
    name: 'meb3',
    component: () => import('../views/meb/work.vue')
  },
  // meb工厂专题-车间工艺-详情
  {
    path: '/workshop',
    name: 'workshop',
    component: () => import('../views/meb/workshop.vue')
  },
  // meb工厂专题-技术亮点
  {
    path: '/Lightspot',
    name: 'meb4',
    component: () => import('../views/meb/technology.vue')
  },
  // ID专题
  {
    path: '/id',
    name: 'id',
    component: () => import('../views/id/id.vue')
  },
  // // ID 6.X专题
  {
    path: '/ID.6X',
    name: 'id6',
    component: () => import('../views/id6/id.vue')
  },
  // // ID 3专题
  {
    path: "/ID.3",
    name: "id3",
    component: () => import("../views/id3/id.vue"),
  },
  // ID store专题
  {
    path: '/ID.store',
    name: 'IDstore',
    component: () => import('../views/id-store/id.vue')
  },
  // // 途观专题
  {
    path: '/Tiguan',
    name: 'tiguan',
    component: () => import('../views/tiguan/id.vue')
  },
  // 帕萨特专题
  {
    path: '/passat',
    name: 'passat',
    component: () => import('../views/passat/id.vue')
  },
  // 明锐pro
  {
    path: '/octavia_pro',
    name: 'octavia_pro',
    component: () => import('../views/octavia-pro/id.vue')
  },
  // /* -------- 专题版块 END -------- */
  // 汽车课堂
  {
    path: '/classroom',
    name: 'Classroom',
    component: () => import('../views/classroom/Classroom.vue')
  },
  // crs社会责任
  {
    path: '/csr',
    name: 'csr',
    component: () => import('../views/csr/scene.vue')
  },
  // // 英文网站-首页
  {
    path: '/home_en',
    name: 'home_en',
    component: () => import('../views/english/englishHome.vue')
  },
  // // 英文网站-介绍
  {
    path: '/about_en',
    name: 'about_en',
    component: () => import('../views/english/englishAbout.vue')
  },
  // // 英文网站-品牌
  {
    path: '/brand_en',
    name: 'brand_en',
    component: () => import('../views/english/englishBrand.vue')
  },
  // // 英文网站-搜索
  {
    path: '/search_en',
    name: 'search_en',
    component: () => import('../views/english/englishSearch.vue')
  },
];

// 发布环境
// 测试地址：http://47.101.168.130
// 正式地址：https://www.csvw.com

const routes1 = [
  // // 官网专题列表
  {
    path: '/subject/subjectList',
    name: 'subjectList',
    component: () => import('../views/list/List.vue')
  },
  // // 图片展
  {
    path: '/subject/pictheme',
    name: 'Pictheme',
    component: () => import('../views/picshow/Pictheme.vue')
  },
  // // 媒体中心-重庆车展
  {
    path: '/subject/exhibition',
    name: 'Exhibition',
    component: () => import('../views/exhibition/Exhibition.vue')
  },
  // // 粤港澳车展
  {
    path: '/subject/exhibitionyga',
    name: 'Exhibitionyga',
    component: () => import('../views/exhibition-yga/Exhibition.vue')
  },
  //  成都车展
  {
    path: '/subject/exhibitioncd',
    name: 'Exhibitioncd',
    component: () => import('../views/exhibition-cd/Exhibition.vue')
  },
  // 成都车展24届
  {
    path: '/subject/exhibitioncd24th',
    name: 'exhibitioncd24th',
    component: () => import('../views/exhibition-cd24th/Exhibition.vue')
  },
  // // 北京车展
  {
    path: '/subject/exhibitionbj',
    name: 'Exhibitionbj',
    component: () => import('../views/exhibition-bj/Exhibition.vue')
  },
  // 上海车展
  {
    path: '/subject/exhibitionsh19th',
    name: 'Exhibitionsh',
    component: () => import('../views/exhibition-sh/Exhibition.vue')
  },
  // 300万下线
  {
    path: '/subject/offline',
    name: 'Offline',
    component: () => import('../views/offline/Offline.vue')
  },
  // // 威然试驾
  {
    path: '/subject/viloranDrive',
    name: 'ViloranDrive',
    component: () => import('../views/viloran-drive/ViloranDrive.vue')
  },
  // // 斯柯达试驾
  {
    path: '/subject/skodaDrive',
    name: 'SkodaDrive',
    component: () => import('../views/skoda-drive/SkodaDrive.vue')
  },
  // // 千里行
  {
    path: '/subject/phev',
    name: 'phev',
    component: () => import('../views/phev/phev.vue')
  },
  // // 长沙工厂专题
  {
    path: '/subject/factory',
    name: 'factory',
    component: () => import('../views/factory/factory.vue')
  },
  // meb工厂专题-现场直播
  {
    path: '/subject/meb',
    name: 'meb',
    component: () => import('../views/meb/scene.vue')
  },
  // meb工厂专题-工厂概述
  {
    path: '/subject/overview',
    name: 'meb2',
    component: () => import('../views/meb/summary.vue')
  },
  // meb工厂专题-车间工艺
  {
    path: '/subject/Technology',
    name: 'meb3',
    component: () => import('../views/meb/work.vue')
  },
  // meb工厂专题-车间工艺-详情
  {
    path: '/subject/workshop',
    name: 'workshop',
    component: () => import('../views/meb/workshop.vue')
  },
  // meb工厂专题-技术亮点
  {
    path: '/subject/Lightspot',
    name: 'meb4',
    component: () => import('../views/meb/technology.vue')
  },
  // ID专题
  {
    path: '/subject/ID',
    name: 'id',
    component: () => import('../views/id/id.vue')
  },
  // // ID 6.x专题
  {
    path: '/subject/ID.6X',
    name: 'id6',
    component: () => import('../views/id6/id.vue')
  },
  // // 途观专题
  {
    path: '/subject/Tiguan',
    name: 'tiguan',
    component: () => import('../views/tiguan/id.vue')
  },
  // 帕萨特专题
  {
    path: '/subject/passat',
    name: 'passat',
    component: () => import('../views/passat/id.vue')
  },
  // 明锐pro
  {
    path: '/subject/octavia_pro',
    name: 'octavia_pro',
    component: () => import('../views/octavia-pro/id.vue')
  },
  // // ID store专题
  {
    path: '/subject/ID.store',
    name: 'IDstore',
    component: () => import('../views/id-store/id.vue')
  },
  // ID 3专题
  {
    path: "/subject/ID.3",
    name: "id3",
    component: () => import("../views/id3/id.vue"),
  },
  // /* -------- 专题版块 END -------- */
  // 汽车课堂
  {
    path: '/technology/classroom',
    name: 'Classroom',
    component: () => import('../views/classroom/Classroom.vue')
  },
  // crs社会责任，注意路径多了一层，多了一个/
  {
    path: '/csvw/thirdpart/responsibility/',
    name: 'csr',
    component: () => import('../views/csr/scene.vue')
  },
  // // 英文网站-首页
  {
    path: '/qiye/home_en',
    name: 'home_en',
    component: () => import('../views/english/englishHome.vue')
  },
  // // 英文网站-介绍
  {
    path: '/qiye/about_en',
    name: 'about_en',
    component: () => import('../views/english/englishAbout.vue')
  },
  // 英文网站-品牌
  {
    path: '/qiye/brand_en',
    name: 'brand_en',
    component: () => import('../views/english/englishBrand.vue')
  },
  // 英文网站-搜索
  {
    path: '/qiye/search_en',
    name: 'search_en',
    component: () => import('../views/english/englishSearch.vue')
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: process.env.NODE_ENV == "development" ? routes : routes1,
});

export default router;
